module.exports = __webpack_public_path__ + "img/wdcgq4.fa29667c.png";